import React from 'react';
import { Layout, Button, Popover } from 'antd';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import { assetsRestCrudThunksForBuyer } from '../../thunks/assets_thunks';
import {
	getProtectedImageUriForBuyer,
	getProtectedImageUriFromString,
} from '../../utils/FileAccessUtils';
import { Link } from 'react-router-dom';
import { EnterOutlined } from '@ant-design/icons';
import { getEntityById, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import AssetDetailLabels from '../LabelDisplay/AssetDetailLabels';
import { ROLE_TYPES } from '../../utils/DataConstants';
import Carousel, { Modal as Lightbox, ModalGateway } from 'react-images';
import { clearNavbarState, updateNavbarState } from '../../actions/navbar_actions';
import {
	generateBackLink,
	getBackLinkStates,
	getLinkWIthBackLinkParams,
} from '../../utils/HistoryUtils';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import TransferAssetToLocationForm from '../supplier_assets_detail_page/TransferAssetToLocationForm';
import NextPreviousButton from '../next_previous_button/NextPreviousButton';
import { ASSETS_CRUD_ACTION_CREATORS } from '../../actions/assets_actions';
import { updatePaginationEntities } from '../../thunks/thunks_wrapper';
import OWButtonWithSupplierManagedLock from '../common/OWButtonWithSupplierManagedLock';
import DeleteConfirmButton from '../delete_pop_confirm/DeletePopConfirm';

require('./AssetsDetailPage.less');
const queryString = require('qs');

const { Content } = Layout;
const DEFAULT_BACK_LINK = '/buyer/assets';

class AssetsDetailPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			lightboxIsOpen: false,
			currentIndex: 0,
			manualsIncluded: false,
			backLinkTo: DEFAULT_BACK_LINK,
			backLinkText: 'Back to assets',
			transferModalVisible: false,
			fromTargetCollectionName: null,
		};
	}

	handleViewChange = (idx) => {
		this.setState({ currentIndex: idx });
	};

	openLightbox = (currentIndex = 0) => {
		this.setState({ lightboxIsOpen: true, currentIndex });
	};

	closeLightbox = () => {
		this.setState({ lightboxIsOpen: false });
	};

	// Sync the global navbar back-link (and in-page backLinkTo) from the current
	// location's backlinkParams. React Router reuses this component across asset
	// ids (e.g. clicking "Sub Asset of {parent}", or a sub asset's "Back to Asset"
	// button), so this must run on every location change — not just on mount — or
	// the back button would keep pointing at the previously viewed asset.
	syncNavbarFromLocation = () => {
		const { updateNavbar, location } = this.props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const { backLinkText: navBackLinkText, backLinkTo: navBackLinkTo } = getBackLinkStates(
			location,
			'/buyer/assets/overview/all'
		) as any;
		updateNavbar(
			navBackLinkText || 'Back to Assets',
			navBackLinkTo || generateBackLink('/buyer/assets/overview/all', location)
		);
		const queryParams = queryString.parse(searchString);
		if (queryParams.targetCollectionName) {
			this.setState({
				fromTargetCollectionName: queryParams.targetCollectionName,
			});
		}
		this.setState({
			backLinkTo: queryParams.backlinkParams
				? `/buyer/assets/overview/all?${queryParams.backlinkParams}`
				: `/buyer/assets/overview/all`,
		});
	};

	componentDidMount() {
		const { getAsset, match } = this.props;

		const assetId = match.params.id;
		this.syncNavbarFromLocation();
		this.setState({ loading: false });

		// Always refetch on mount. The Redux record cached after a create/copy
		// (or from the list page) may not have nested relations hydrated
		// (e.g. `parent` for a freshly-created sub asset), which the detail
		// banner depends on. The cost is one extra readOne; correctness wins.
		getAsset(assetId).then((fetched) => {
			this.setState({ manualsIncluded: !!nullSafeGet('assetModel.manuals', fetched) });
		});
	}
	componentDidUpdate(prevProps) {
		// React Router reuses this component when the asset id (or query) in the URL
		// changes (e.g. clicking the "Sub Asset of {parent}" link), so we re-sync the
		// navbar and refetch here — componentDidMount only fires on the initial mount.
		const prevId = prevProps.match.params.id;
		const nextId = this.props.match.params.id;
		if (prevProps.location.search !== this.props.location.search || prevId !== nextId) {
			this.syncNavbarFromLocation();
		}
		if (prevId !== nextId) {
			const { getAsset, asset } = this.props;
			if (!nullSafeGet('id', asset) || String(asset.id) !== String(nextId)) {
				getAsset(nextId).then((fetched) => {
					this.setState({
						manualsIncluded: !!nullSafeGet('assetModel.manuals', fetched),
					});
				});
			}
		}
	}

	componentWillUnmount(): void {
		this.props.clearNavbar();
	}

	handleTabChange = (key) => {
		const { history, match, location } = this.props;
		const assetId = match.params.id;
		const path = `/buyer/assets/detail/${assetId}/${key}`;
		history.push(`${path}?${getBackLinkStates(location, path).backLinkParams || ''}`);
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	};

	handleDelete = () => {
		const { history, deleteAsset, asset } = this.props;
		deleteAsset(asset).then(() => {
			history.push('/buyer/assets/overview/all');
		});
	};

	showTransferModal = () => this.setState({ transferModalVisible: true });
	hideTransferModal = () => this.setState({ transferModalVisible: false });

	onTransferSuccess = () => {
		const { getAsset, match } = this.props;
		const assetId = match.params.id;
		this.hideTransferModal();
		getAsset(assetId);
	};

	handleCopy = () => {
		const { match, history, userType, location } = this.props;
		const assetId = match.params.id;
		history.push(
			getLinkWIthBackLinkParams(
				location,
				'Back to asset',
				`/${userType}/assets/overview/new?copyFromAssetId=${assetId}`
			)
		);
	};

	onEdit = () => {
		const { history, match, userType, location } = this.props;
		const assetId = match.params.id;
		const toLink = getLinkWIthBackLinkParams(
			location,
			'Back to Asset',
			`/${userType}/assets/edit/${assetId}`
		);
		history.push(toLink);
	};

	render() {
		const {
			asset,
			assetsFetching,
			match,
			location,
			history,
			assets,
			updatePagination,
			cloneTargetCollection,
			companyConfig,
			userType,
		} = this.props;
		const assetId = match.params.id;
		const assetIsSubAsset = !!nullSafeGet('parentId', asset);
		const subAssetsEnabled = nullSafeGetOrElse(
			'config.assetConfig.allowSubAssets',
			companyConfig,
			false
		);
		let tabs = [
			{
				key: 'details',
				name: 'Overview',
			},
			// Sub assets don't track their own downtime, so hide the tab.
			...(assetIsSubAsset
				? []
				: [
						{
							key: 'downtimeHistory',
							name: 'Downtime History',
						},
				  ]),
			{
				key: 'audit',
				name: 'Audit Logs',
			},
		];
		// Data-driven rather than config-driven: the tab exists for an appliance that is enrolled in
		// the refrigerant programme, and for no other asset. Nothing on it would have a value to
		// show otherwise — the leak rate has no denominator until a full charge is recorded.
		if (nullSafeGet('isRefrigerantTracked', asset)) {
			tabs.push({ key: 'refrigerantTracking', name: 'Refrigerant Tracking' });
		}
		if (this.state.manualsIncluded) {
			tabs.push({ key: 'manuals', name: 'Manuals' });
		}
		// Sub assets are a single level deep — don't show the tab on an asset that
		// is itself a sub asset, or when the buyer company hasn't enabled the feature.
		if (!assetIsSubAsset && subAssetsEnabled) {
			tabs.push({ key: 'subAssets', name: 'Sub Assets' });
		}
		let photoUris = [];
		let lightboxPhotoUris = [];
		if (asset.images && asset.images.length) {
			photoUris = asset.images.slice(0, 4).map((assetImg) => {
				const [imgFileId, imgFileName] = assetImg.split('/');
				return getProtectedImageUriForBuyer(imgFileId, imgFileName, 1200, 800);
			});
			lightboxPhotoUris = asset.images.map((photoString) => ({
				src: getProtectedImageUriFromString(ROLE_TYPES.BUYER)(photoString, 2400, 1600),
			}));
		}
		const fetching = assetsFetching && !nullSafeGet('id', asset);
		const isSubAsset = !!nullSafeGet('parentId', asset);

		return (
			<div>
				<Route
					path="/buyer/assets/detail/:id"
					exact={true}
					render={() => (
						<Redirect
							to={{
								pathname: `/buyer/assets/detail/${assetId}/details`,
							}}
						/>
					)}
				/>
				<Content className="assetsDetailPage">
					{/*<ScrollToTopOnMount/>*/}
					{/*<BackTop/>*/}
					<ModalGateway>
						{this.state.lightboxIsOpen ? (
							<Lightbox onClose={this.closeLightbox}>
								<Carousel
									trackProps={{
										onViewChange: this.handleViewChange,
									}}
									views={lightboxPhotoUris}
									currentIndex={this.state.currentIndex}
								/>
							</Lightbox>
						) : null}
					</ModalGateway>

					<div className="imageLayout">
						{photoUris.map((photoUri, idx) => (
							<div
								key={idx}
								className={`imageTile imageTile${idx}`}
								style={{ backgroundImage: `url(${photoUri})` }}
							/>
						))}
						<div
							className={`imageLayout__gradientOverlay ${
								asset.isActive ? '' : 'imageLayout__gradientOverlay--darker'
							}`}
						>
							{!asset.isActive ? <div className="assetInactiveLabel">Inactive</div> : null}
							{assetIsSubAsset && nullSafeGet('parent.name', asset) ? (
								<div className="flex flex-row items-center" style={{ color: '#ffffffcc' }}>
									<EnterOutlined className="mr-1" style={{ transform: 'scaleX(-1)' }} />
									<span>
										Sub Asset of{' '}
										{nullSafeGet('parent.id', asset) || nullSafeGet('parentId', asset) ? (
											<Link
												to={getLinkWIthBackLinkParams(
													location,
													'Back to Sub Asset',
													`/${userType}/assets/detail/${
														nullSafeGet('parent.id', asset) || nullSafeGet('parentId', asset)
													}/details`,
													{ preserve: true }
												)}
												style={{ color: 'inherit', textDecoration: 'underline' }}
											>
												{nullSafeGet('parent.name', asset)}
											</Link>
										) : (
											nullSafeGet('parent.name', asset)
										)}
									</span>
								</div>
							) : null}
							{/* One text flow: name, type and chips, so the chips land at the end of the last
							    line instead of taking a row of their own once the name wraps. */}
							<div className="mb-4 max-w-[calc(100%_-_200px)] break-words">
								<h4
									className="assetsDetailPage__title mr-3 inline align-middle"
									style={{ marginBottom: 0 }}
								>
									{fetching ? null : asset.name}
								</h4>
								<span className="assetsDetailPage__overtitle mr-3 inline align-middle">
									{nullSafeGet('assetType.name', asset)}
								</span>
								<span className="inline-flex flex-wrap items-center gap-2 py-2 align-middle">
									<AssetDetailLabels asset={asset} />
								</span>
							</div>
							<SubnavTabs
								tabs={tabs}
								onChange={this.handleTabChange}
								isActive={this.checkTabActive}
							/>
							<div style={{ position: 'absolute', top: 40, right: 40 }}>
								<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_ASSETS}>
									<OWButtonWithSupplierManagedLock
										ghost={true}
										onClick={this.onEdit}
										style={{ marginRight: 16 }}
									>
										Edit
									</OWButtonWithSupplierManagedLock>
								</AccessPermissionChecker>
								<AccessPermissionChecker name={PERMISSION_NAMES.DELETE_ASSETS}>
									<DeleteConfirmButton
										onConfirm={this.handleDelete}
										title={
											assetIsSubAsset ? (
												'Are you sure you want to delete this sub asset?'
											) : nullSafeGetOrElse('subAssetCount', asset, 0) > 0 ? (
												<div style={{ maxWidth: 320 }}>
													<div>Are you sure you want to delete this asset?</div>
													<div style={{ marginTop: 8 }}>
														It has {asset.subAssetCount} sub asset
														{asset.subAssetCount === 1 ? '' : 's'}, which will also be deleted.
													</div>
												</div>
											) : (
												'Are you sure you want to delete this asset?'
											)
										}
									>
										<OWButtonWithSupplierManagedLock ghost={true} style={{ marginRight: 16 }}>
											Delete
										</OWButtonWithSupplierManagedLock>
									</DeleteConfirmButton>
								</AccessPermissionChecker>
								<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_ASSETS}>
									<Popover
										content={isSubAsset ? 'Sub assets cannot be copied to create a new asset' : ''}
										trigger="hover"
									>
										<span style={{ display: 'inline-block', marginRight: 16 }}>
											<OWButtonWithSupplierManagedLock
												ghost={true}
												onClick={this.handleCopy}
												disabled={isSubAsset}
											>
												Copy and create new
											</OWButtonWithSupplierManagedLock>
										</span>
									</Popover>
									<Popover
										content={
											isSubAsset
												? 'Sub assets cannot be transferred'
												: !asset.isActive
												? 'Inactive assets cannot be transferred'
												: ''
										}
										trigger="hover"
									>
										<span style={{ display: 'inline-block' }}>
											<OWButtonWithSupplierManagedLock
												ghost={true}
												onClick={this.showTransferModal}
												disabled={!asset.isActive || fetching || isSubAsset}
											>
												Transfer
											</OWButtonWithSupplierManagedLock>
										</span>
									</Popover>
								</AccessPermissionChecker>
							</div>
							<div
								style={{ position: 'absolute', bottom: 40, right: 40 }}
								className="flex flex-row items-baseline"
							>
								{lightboxPhotoUris.length > 0 ? (
									<Button
										style={{ color: 'white', marginRight: 16 }}
										type="ghost"
										onClick={() => this.openLightbox()}
									>
										View Photos
									</Button>
								) : null}
								<NextPreviousButton
									key={this.state.fromTargetCollectionName}
									location={location}
									history={history}
									activeId={nullSafeGet('id', asset)}
									getEnitityUrl={(id) => `/buyer/assets/detail/${id}/details`}
									stateSlice={assets}
									targetCollectionName={this.state.fromTargetCollectionName}
									updatePagination={updatePagination}
									cloneTargetCollection={cloneTargetCollection}
									entityName="asset"
								/>
							</div>
						</div>
					</div>
					{this.props.childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
					{this.state.transferModalVisible ? (
						<TransferAssetToLocationForm
							asset={asset}
							onCancel={this.hideTransferModal}
							onSuccess={this.onTransferSuccess}
						/>
					) : null}
				</Content>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	assetsFetching: state.assets.fetching,
	asset: getEntityById(ownProps.match.params.id, state.assets),
	userType: state.session.userType,
	assets: state.assets,
	companyConfig: state.company_config.detail,
});

const mapDispatchToProps = (dispatch) => ({
	getAsset: (id) => dispatch(assetsRestCrudThunksForBuyer.readOne(id)),
	deleteAsset: (entity) => dispatch(assetsRestCrudThunksForBuyer.delete(entity, 'id', null, true)),
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
	clearNavbar: () => dispatch(clearNavbarState()),
	cloneTargetCollection: (from, to) =>
		dispatch(ASSETS_CRUD_ACTION_CREATORS.cloneTargetCollection(from, to)),
	updatePagination: (pagination, targetCollectionName) =>
		dispatch(
			updatePaginationEntities('buyer', 'assets', assetsRestCrudThunksForBuyer)(
				false,
				undefined,
				targetCollectionName,
				pagination,
				true
			)
		),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetsDetailPage));
